<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading"
    class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p onclick="history.back()">Complaints</p>
    <p>View Received Complaint</p>
</div>



<div *ngIf="!isLoading">
    <div class="w-full px-10 py-7 bg-white dark:bg-[#363636] shadow-lg rounded-lg mt-5">
        <div class="flex flex-col justify-center dark:text-textDark items-center gap-3 mb-8">
            <p class="text-lg">
                Ref No : <span class="font-bold dark:text-white">{{compalintObj.refNo}}</span>
            </p>
            <p>
                Preferred Language : <span class="font-bold dark:text-white">{{compalintObj.language}}</span>
            </p>
            <p>Received : {{compalintObj.createdAt | date:'yyyy/MM/dd'}} at {{compalintObj.createdAt | date:'hh:mm a'}}
            </p>
        </div>

        <div class="grid grid-cols-4 gap-6 mb-6">
            <div class="flex flex-row items-center gap-5 col-span-2">
                <p class="font-medium text-gray-600 dark:text-textDark mr-16">Category</p>
                <input type="text"
                    class="w-full bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    [value]="compalintObj.complainCategory" disabled />
            </div>

            <div class="flex flex-row items-start gap-5 col-span-4">
                <p class="font-medium text-gray-600 dark:text-textDark mr-14">Complaint</p>
                <textarea
                    class="w-full bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    rows="6" [value]="compalintObj.complain" disabled>
                </textarea>
            </div>

            <div class="flex flex-row items-center gap-5 col-span-2 ">
                <p class="font-medium text-gray-600 dark:text-textDark mr-10">Complainant</p>
                <input type="text"
                    class="w-1/2 bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    [value]="officerName" disabled />
            </div>

            <div class="flex flex-row items-center gap-16 col-span-2">
                <p class="font-medium text-gray-600 dark:text-textDark mr-10">EMP ID</p>
                <input type="text"
                    class="w-1/2 bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    [value]="compalintObj.empId" disabled />
            </div>

            <div class="flex flex-row items-center gap-5 col-span-2">
                <p class="font-medium text-gray-600 dark:text-textDark">Mobile Number 01</p>
                <input type="text"
                    class="w-1/2 bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    [value]="phone1" disabled />
            </div>
            <div class="flex flex-row items-center gap-5 col-span-2">
                <p class="font-medium text-gray-600 dark:text-textDark">Mobile Number 02</p>
                <input type="text"
                    class="w-1/2 bg-gray-100 dark:bg-[#1D1D1F] text-gray-900 dark:text-textDark border rounded-lg px-3 py-2"
                    [value]="phone2" disabled />
            </div>
        </div>

        <div class="flex justify-center gap-6 mt-6">
            <button *ngIf="compalintObj.reply === null"
                class="font-semibold border-[1px] shadow-lg px-4 py-2 rounded-lg"
                [ngClass]="{
                    'bg-[#F6F7F9] dark:bg-gray-600 text-[#6B7D8C] dark:text-white': compalintObj.reply === null,
                    'bg-gray-300 dark:bg-gray-500 text-gray-500 dark:text-gray-300 cursor-not-allowed': compalintObj.reply !== null}" [disabled]="compalintObj.reply !== null"
                (click)="forwordComplain()">
                Forward
            </button>
            <button class="bg-[#415CFF] text-white font-semibold shadow-lg px-7 py-2 rounded-lg" (click)="replyBtn()">
                Reply
            </button>
        </div>
    </div>


    <div *ngIf="isReplyView" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white dark:bg-[#363636] shadow-lg rounded-lg p-6 w-1/2">
            <div class="flex flex-col items-center justify-center gap-5">
                <div class="bg-[#F6F6F6] rounded-full shadow-md py-2 px-3">
                    <i class="fa-regular fa-envelope text-2xl"></i>
                </div>

                <div class="flex flex-col w-full border-[1px] border-[#D9D9D9] py-4 px-5 rounded-lg dark:text-white">
                    <div>
                        <p class="gap-y-2 mb-1">
                            {{compalintObj.language === 'Sinhala' ? 'හිතවත් ': compalintObj.language === 'Tamil' ?
                            'அன்புள்ள ' : 'Dear '}}
                            <span class="font-semibold">{{compalintObj.firstNameEnglish}}
                                {{compalintObj.lastNameEnglish}},</span>
                        </p>

                        <p *ngIf="compalintObj.language === 'Sinhala'">
                            ඔබගේ පැමිණිල්ල නිරාකරණය කර ඇති බව ඔබට දැනුම් දීමට අපි සතුටු වෙමු.
                        </p>

                        <p *ngIf="compalintObj.language === 'Tamil'">
                            உங்கள் முறையீடு தீர்வு செய்யப்பட்டதாக தெரிவித்து மகிழ்ச்சியடைகிறோம்.
                        </p>

                        <p *ngIf="compalintObj.language !== 'Sinhala' && compalintObj.language !== 'Tamil'">
                            We are pleased to inform you that your complaint has been resolved.
                        </p>

                        <div
                            class="border-none mt-2 mb-1 outline-none bg-[#F6F6F6] dark:bg-[#363636] rounded-lg w-full h-28 p-1">
                            <textarea rows="5"
                                class="bg-[#F6F6F6] dark:bg-[#363636] resize-none w-full h-full border-none outline-none "
                                cols="6" [(ngModel)]="replyObj.reply" name="reply"
                                placeholder="[ Add message here... ]"></textarea>
                        </div>

                    </div>

                    <div class="flex flex-col mb-2">
                        <p class="mt-2">
                            {{
                            compalintObj.language === 'Sinhala' ? 'ඔබට තවත් ගැටළු හෝ ප්‍රශ්න තිබේ නම්, කරුණාකර අප හා
                            සම්බන්ධ
                            වන්න. '
                            : compalintObj.language === 'Tamil' ? 'உங்களுக்கு மேலும் ஏதேனும் சிக்கல்கள் அல்லது கேள்விகள்
                            இருந்தால், தயவுசெய்து எங்களைத் தொடர்பு கொள்ளவும்'
                            : 'If you have any further concerns or questions, feel free to reach out.'
                            }}

                        </p>

                        <p class="">
                            {{
                            compalintObj.language === 'Sinhala'
                            ? 'ඔබේ ඉවසීම සහ අවබෝධය වෙනුවෙන් ස්තූතියි.'
                            : compalintObj.language === 'Tamil'
                            ? 'உங்கள் பொறுமைக்கும் புரிதலுக்கும் நன்றி.'
                            : 'Thank you for your patience and understanding.'
                            }}
                        </p>
                    </div>

                    <p>
                        {{
                        compalintObj.language === 'Sinhala' ? 'මෙයට,'
                        : compalintObj.language === 'Tamil' ? 'இதற்கு,'
                        : 'Sincerely,'
                        }}
                    </p>

                    <p>
                        {{
                        compalintObj.language === 'Sinhala' ? templateData.SinName
                        : compalintObj.language === 'Tamil' ? templateData.TamName
                        : templateData.EngName
                        }}
                    </p>

                    <p>
                        {{
                        compalintObj.language === 'Sinhala' ? 'Collection Centre Head of ' +
                        templateData.companyNameSinhala
                        : compalintObj.language === 'Tamil' ? 'Collection Centre Head of ' +
                        templateData.companyNameTamil
                        : 'Collection Centre Head of ' + templateData.companyNameEnglish
                        }}
                    </p>
                </div>



                <div class="flex flex-row justify-center items-center gap-8">
                    <button
                        class="bg-[#F6F7F9] dark:bg-gray-600 text-[#6B7D8C] dark:text-white font-semibold border-[1px] shadow-lg px-4 py-2 rounded-lg"
                        (click)="cancelViewReply()">
                        Go Back
                    </button>
                    <button class="bg-[#415CFF] text-white font-semibold rounded-lg shadow-lg px-6 py-2"
                        (click)="sendReply()">
                        Send
                    </button>
                </div>

            </div>

        </div>
    </div>
</div>